import { MATCH_TIPO_RES, MATCH_RESULTADO } from '../constants/tournament.constants';

/**
 * Given a raw DB partida record, returns the human-readable result string
 * used in the wizard UI ('1 - 0', '½ - ½', '+ - -', etc.).
 * For BYE matches (individual tournaments), also returns { byeValue }.
 *
 * @param {object} partida - Raw DB record with par_tipo_res_blancas, par_resultado_blancas, par_resultado_negras
 * @returns {{ result: string, byeValue: string|null, isBye: boolean }}
 */
export function parseMatchResult(partida) {
  const isBye = partida.par_tipo_res_blancas === MATCH_TIPO_RES.BYE;
  let result = '';
  let byeValue = null;

  if (isBye) {
    if (partida.par_resultado_blancas === MATCH_RESULTADO.VICTORIA) byeValue = '1';
    else if (partida.par_resultado_blancas === MATCH_RESULTADO.EMPATE) byeValue = '½';
    else if (partida.par_resultado_blancas === MATCH_RESULTADO.DERROTA) byeValue = '0';
  } else {
    const rb = partida.par_resultado_blancas;
    const rn = partida.par_resultado_negras;
    const tb = partida.par_tipo_res_blancas;

    if (tb === MATCH_TIPO_RES.NORMAL) {
      if (rb === MATCH_RESULTADO.VICTORIA && rn === MATCH_RESULTADO.DERROTA) result = '1 - 0';
      else if (rb === MATCH_RESULTADO.DERROTA && rn === MATCH_RESULTADO.VICTORIA) result = '0 - 1';
      else if (rb === MATCH_RESULTADO.EMPATE && rn === MATCH_RESULTADO.EMPATE) result = '½ - ½';
    } else if (tb === MATCH_TIPO_RES.AUSENCIA) {
      if (rb === MATCH_RESULTADO.VICTORIA && rn === MATCH_RESULTADO.DERROTA) result = '+ - -';
      else if (rb === MATCH_RESULTADO.DERROTA && rn === MATCH_RESULTADO.VICTORIA) result = '- - +';
      else if (rb === MATCH_RESULTADO.DERROTA && rn === MATCH_RESULTADO.DERROTA) result = '- - -';
    }
  }

  return { result, byeValue, isBye };
}

/**
 * Given a UI result string and optional byeValue, returns the numeric fields
 * for the DB payload (par_resultado_blancas, par_tipo_res_blancas, etc.).
 *
 * @param {string} resultStr - e.g. '1 - 0', '½ - ½', '+ - -'
 * @param {boolean} isBye - whether this is a BYE match (individual tournaments only)
 * @param {string|null} byeValue - '1', '½', or '0' (only when isBye is true)
 * @returns {{ par_resultado_blancas, par_tipo_res_blancas, par_resultado_negras, par_tipo_res_negras }}
 */
export function serializeMatchResult(resultStr, isBye = false, byeValue = null) {
  let par_resultado_blancas = MATCH_RESULTADO.DERROTA;
  let par_tipo_res_blancas = MATCH_TIPO_RES.NORMAL;
  let par_resultado_negras = null;
  let par_tipo_res_negras = null;

  if (isBye) {
    par_tipo_res_blancas = MATCH_TIPO_RES.BYE;
    if (byeValue === '1') par_resultado_blancas = MATCH_RESULTADO.VICTORIA;
    else if (byeValue === '½') par_resultado_blancas = MATCH_RESULTADO.EMPATE;
    else if (byeValue === '0') par_resultado_blancas = MATCH_RESULTADO.DERROTA;
    return { par_resultado_blancas, par_tipo_res_blancas, par_resultado_negras, par_tipo_res_negras };
  }

  if (resultStr === '1 - 0') {
    par_resultado_blancas = MATCH_RESULTADO.VICTORIA;
    par_tipo_res_blancas = MATCH_TIPO_RES.NORMAL;
    par_resultado_negras = MATCH_RESULTADO.DERROTA;
    par_tipo_res_negras = MATCH_TIPO_RES.NORMAL;
  } else if (resultStr === '0 - 1') {
    par_resultado_blancas = MATCH_RESULTADO.DERROTA;
    par_tipo_res_blancas = MATCH_TIPO_RES.NORMAL;
    par_resultado_negras = MATCH_RESULTADO.VICTORIA;
    par_tipo_res_negras = MATCH_TIPO_RES.NORMAL;
  } else if (resultStr === '½ - ½') {
    par_resultado_blancas = MATCH_RESULTADO.EMPATE;
    par_tipo_res_blancas = MATCH_TIPO_RES.NORMAL;
    par_resultado_negras = MATCH_RESULTADO.EMPATE;
    par_tipo_res_negras = MATCH_TIPO_RES.NORMAL;
  } else if (resultStr === '+ - -') {
    par_resultado_blancas = MATCH_RESULTADO.VICTORIA;
    par_tipo_res_blancas = MATCH_TIPO_RES.AUSENCIA;
    par_resultado_negras = MATCH_RESULTADO.DERROTA;
    par_tipo_res_negras = MATCH_TIPO_RES.AUSENCIA;
  } else if (resultStr === '- - +') {
    par_resultado_blancas = MATCH_RESULTADO.DERROTA;
    par_tipo_res_blancas = MATCH_TIPO_RES.AUSENCIA;
    par_resultado_negras = MATCH_RESULTADO.VICTORIA;
    par_tipo_res_negras = MATCH_TIPO_RES.AUSENCIA;
  } else if (resultStr === '- - -') {
    par_resultado_blancas = MATCH_RESULTADO.DERROTA;
    par_tipo_res_blancas = MATCH_TIPO_RES.AUSENCIA;
    par_resultado_negras = MATCH_RESULTADO.DERROTA;
    par_tipo_res_negras = MATCH_TIPO_RES.AUSENCIA;
  }

  return { par_resultado_blancas, par_tipo_res_blancas, par_resultado_negras, par_tipo_res_negras };
}
